// import Globals from './../../globals'
import httpService from "../../service";
import cacheService from "@/services/cache";

const d3 = require("d3");

export const loadModulesMixin = {
    methods: {
        loadModulesNew() {
            let groups = this.groups;
            let groupsElts = {};
            let g;
            let modulesUnavailable = this.getPlanoDetails.modulesUnavailable ? this.getPlanoDetails.modulesUnavailable : [];
            let container = d3.select("#meubleInt").raise();
            let currentLang = cacheService.getUserLang();
            groups.forEach(group => {
                g = container.append("g");
                g.data([
                    {
                        groupId: group.id,
                        selected: false
                    }
                ]);
                groupsElts[group.id] = g;
            });
            let promises = [];
            groups.forEach(group => {
                group.modules.forEach(module => {
                    // let idModule = parseInt(module.id, 10)
                    promises.push(this.loadModule(module, groupsElts));
                });
            });
            Promise.all(promises).then(() => {
                if (modulesUnavailable.length > 0) {
                    let errorModules = "";
                    modulesUnavailable.forEach(function(module) {
                        errorModules += "<li>" + module.terms.name[currentLang].value + " (" + module.id + ")</li>";
                    });

                    this.$swal({
                        title: this.$t("planobuilder.warning"),
                        width: 600,
                        customClass: "popinErrorModal",
                        html: "<p>" + this.$t("planobuilder.popinModuleErrorTitle") + "</p>" + errorModules,
                        type: "warning",
                        confirmButtonColor: "#41b4e8",
                        confirmButtonText: "Ok"
                    });
                }
                this.loader = false;
                console.timeEnd("plano");
            });
        },

        loadModulesOld() {
            let groups = this.groups;
            //                console.log(groups)
            //                let accessories = this.accessories
            let cmpsIsupdated = {
                datas: {}
            };
            // let countTotalModule = 0
            // let countLoadModule = 0
            // console.log(this.getModules())
            groups.forEach(group => {
                group.modules.forEach(mod => {
                    let timestamp = mod.timestamp ? mod.timestamp : 0;
                    // countTotalModule++
                    cmpsIsupdated.datas[mod.id] = {
                        id: mod.id,
                        flag: false,
                        timestampModified: timestamp
                    };
                    if (cmpsIsupdated.datas[mod.id].timestampModified > timestamp) {
                        cmpsIsupdated.datas[mod.id].timestampModified = timestamp;
                    }
                });
            });
            let groupsElts = {};
            let g;
            let container = d3.select("#meubleInt").raise();
            groups.forEach(group => {
                g = container.append("g");
                g.data([
                    {
                        groupId: group.id,
                        selected: false
                    }
                ]);
                groupsElts[group.id] = g;
            });
            let promise = this.promiseModule(groupsElts, cmpsIsupdated);
            let promise2 = new Promise(resolve => {
                httpService
                    .post("/shades/isupdated/" + this.$route.params.id)
                    .then(res => {
                        let modules = this.getModules();
                        res.forEach(shade => {
                            if (shade.is_update) {
                                modules.forEach(mod => {
                                    if (mod.config) {
                                        if (mod.config.groups) {
                                            mod.config.groups.forEach(m => {
                                                if (m.color && m.color.id === shade.id) {
                                                    // console.log(m.color, shade)
                                                    m.color.color = shade.color;
                                                    m.color.ref = shade.number;
                                                    // m.color.ref = shade.color
                                                }
                                            });
                                        }
                                    }
                                    this.loadColor(document.getElementById(mod.UUID), mod);
                                });
                            }
                        });
                        return true;
                    })
                    .then(() => {
                        resolve(true);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
            Promise.all([promise, promise2]).then(() => {
                this.modulesSvgLoad().then(() => {
                    this.loader = false;
                    if (this.hasError) {
                        this.$swal({
                            title: this.$t("planobuilder.warning"),
                            html: "Attention la mise à jour des modules:<br/>" + this.messageError,
                            type: "warning",
                            //                                showCancelButton: true,
                            confirmButtonColor: "#41b4e8",
                            confirmButtonText: "Ok"
                            // cancelButtonText: 'Non'
                        });
                    }
                    // console.timeEnd('loadmodule')
                });
                // }
            });
        },

        promiseModule(groupsElts, cmpsIsupdated) {
            let promises = [];
            let modules = this.getModules();
            return new Promise((resolve, reject) => {
                httpService
                    .post("/components/isupdated", JSON.stringify(cmpsIsupdated))
                    .then(res => {
                        if (res.status === 400) throw res.message;
                        let datas = res.datas;
                        let canModifModule;
                        let idModules = datas instanceof Object ? Object.keys(datas) : [];
                        idModules.forEach(idMod => {
                            let data = datas[idMod];
                            canModifModule = data.flag;
                            if (canModifModule) {
                                // hasSave = true
                                let detail = this.getDetails({ id: idMod })
                                    .then(item => {
                                        if (httpService.hasError(item)) {
                                            console.log("error");
                                            this.countErrorModule++;
                                            this.hasError = true;
                                            this.messageError += "-" + idMod + "<br/>";
                                            let mods = modules.filter(m => {
                                                return parseInt(data.id, 10) === parseInt(m.id, 10);
                                            });
                                            // console.log(mods)
                                            mods.forEach(mod => {
                                                this.loadModule(mod, groupsElts);
                                            });
                                            return null;
                                        }
                                        modules.forEach(module => {
                                            module.timestamp = data.timestampModified;
                                            let idModule = parseInt(module.id, 10);
                                            if (idModule === parseInt(idMod, 10)) {
                                                let svg = this._.find(item.figures_advanced, o => {
                                                    return o.id_type_file === 6;
                                                });
                                                module.src = svg ? svg.big : null;
                                                let imgReal = this._.find(item.figures_advanced, obj => {
                                                    return obj.id_type_file === 5;
                                                });
                                                let srcreal = "";
                                                if (typeof imgReal !== "undefined") {
                                                    if (imgReal) {
                                                        srcreal = imgReal.big;
                                                        module.srcreal = srcreal;
                                                    }
                                                }
                                                let configMod = module.config;
                                                if (!configMod) {
                                                    configMod = {
                                                        texts: {
                                                            name: "",
                                                            refs: {
                                                                DIAM: "",
                                                                client: ""
                                                            }
                                                        }
                                                    };
                                                    module.config = configMod;
                                                }
                                                if (!configMod.texts) {
                                                    configMod.texts = {
                                                        name: "",
                                                        refs: {
                                                            DIAM: "",
                                                            client: ""
                                                        }
                                                    };
                                                }
                                                let nicknameTmp = item.terms.nickname;
                                                let nickname = {};
                                                if (nicknameTmp) {
                                                    let langs = Object.keys(nicknameTmp);
                                                    nickname = {};
                                                    langs.forEach(lang => {
                                                        nickname[lang] = nicknameTmp[lang].value;
                                                    });
                                                } else {
                                                    nickname["fr"] = item.nickname;
                                                    nickname["en"] = item.nickname;
                                                }
                                                configMod.texts.name = nickname;
                                                configMod.texts.refs = {
                                                    DIAM: item.infosArticle.diam_ref1 ? item.infosArticle.diam_ref1.componentProperty.value : "",
                                                    client: item.infosArticle.client_ref1 ? item.infosArticle.client_ref1.componentProperty.value : ""
                                                };
                                                let configItem = item.config;
                                                if (!configMod.groups) {
                                                    configMod.groups = configItem && configItem.groups ? configItem.groups : [];
                                                } else if (configMod.groups instanceof Array && configItem) {
                                                    let hasModif = false;
                                                    if (configItem.groups instanceof Array) {
                                                        if (configMod.groups.length !== configItem.groups.length) {
                                                            hasModif = true;
                                                        } else {
                                                            let groupConf;
                                                            //                                                    configMod.groups.find()
                                                            for (let i = 0; i < configMod.groups.length; i++) {
                                                                groupConf = configMod.groups[i];
                                                                hasModif = this.canModifConfigModule(groupConf, configItem.groups);
                                                                //                                                        console.log(hasModif)
                                                                if (hasModif) break;
                                                            }
                                                        }
                                                    } else {
                                                        configMod.groups = [];
                                                    }
                                                    if (hasModif) {
                                                        configMod.groups = configItem && configItem.groups ? configItem.groups : [];
                                                    }
                                                }
                                                return this.loadModule(module, groupsElts);
                                            }
                                        });
                                        return null;
                                    })
                                    .then(p => {
                                        return p;
                                    });
                                promises.push(detail);
                            } else {
                                let promises3 = [];
                                modules.forEach(module => {
                                    let idModule = parseInt(module.id, 10);
                                    if (idModule === parseInt(idMod, 10)) {
                                        promises3.push(this.loadModule(module, groupsElts));
                                    }
                                });
                                promises.push(Promise.all(promises3));
                            }
                        });
                    })
                    .catch(res => {
                        // console.log('catch ==========')
                        let promises2 = [];
                        modules.forEach(module => {
                            promises2.push(this.loadModule(module, groupsElts));
                        });
                        promises.push(Promise.all(promises2));
                    });
                Promise.all(promises).then(() => {
                    // console.log("finish")
                    resolve(true);
                });
            });
        },

        modulesSvgLoad() {
            // console.log('load ===============================================================')
            let interval;
            return new Promise(resolve => {
                interval = setInterval(() => {
                    let load = this.modulesSvgLoad2();
                    if (load) {
                        clearInterval(interval);
                        resolve(true);
                        console.timeEnd("plano");
                    }
                }, 100);
            });
        },
        modulesSvgLoad2() {
            // console.log(document.querySelector('g#meubleInt').querySelectorAll('svg.module_snap').length)
            // console.log(document.querySelector('g#meubleInt').querySelectorAll('svg.module_snap'))
            // console.log(document.querySelector('g#meubleInt').querySelectorAll('svg.module_snap').length, this.getModules().length)
            let lenEltMod = document.querySelector("g#meubleInt").querySelectorAll("svg.module_snap").length;
            let valid = lenEltMod === this.getModules().length;
            // console.log(d3.select("g#meubleInt").selectAll("svg.module_snap").size(), valid)
            return valid;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/plano/mixins/loadmodules.js